/* eslint-disable jira/naming/disallow-filenames */

import React from 'react';
import type OpsGenieScheduleType from '@jira/spa-apps__project-opsgenie-schedule/src/OpsgenieScheduleApp.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';
import { RedirectToProjectType } from './project-type/index.tsx';

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const LazyOpsGenieSchedule: LazyComponent<React.ComponentType<Record<any, any>>> =
	lazyForPaint<typeof OpsGenieScheduleType>(() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-opsgenie-schedule", jiraSpaEntry: "async-opsgenie-schedule" */ '@jira/spa-apps__project-opsgenie-schedule/src/OpsgenieScheduleApp.tsx'
			),
		),
	);

export const OpsgenieScheduleRedirect = (): React.JSX.Element => (
	<RedirectToProjectType page="/on-call-schedule" />
);

const AsyncOpsGenieSchedule = (): React.JSX.Element => (
	<LazyPage Page={LazyOpsGenieSchedule} pageId="opsgenie-schedule" shouldShowSpinner />
);

export default AsyncOpsGenieSchedule;
